<script>
import { store } from './store.js'
import Layer from './Layer.vue'
import PaintItem from './PaintItem.vue'
import ButtonPanel from './ButtonPanel.vue'

export default {
  components: {
    Layer,
    PaintItem,
    ButtonPanel,
  },
  data() {
    return {
      store
    }
  },

  created(){
  },
  mounted(){
    if (typeof window.initializeLayers === "function") window.initializeLayers();
  },
  updated() {
    if (typeof window.initializeLayers === "function"){
        window.initializeLayers();
    } 
  },
 
  methods: {
    createsnp() {
      window.createSnapshot();
    },
    sortiraj() {
      window.createSort();
    },
    obrisi() {
      window.deleteItem();
    },
  },
};
</script>

<template>

  <div id="opengraphiqpostcanvasapp" class="og-post-canvas-app">

  <ButtonPanel />

  <div id="wrapper" class="og-wrapper">
  <div id="wrapper-inner" class="og-wrapper-inner">

  
  <PaintItem v-for="(item, index) in store.domelements" :item="item" :index="index" :key="item.id" />
  
  </div>
  </div>

<div id="layers_temp" class="og-layers">
	  <div class="layers-header">
		  <h2 class="handle">Layers</h2>
	  </div><!-- .postbox_temp-header -->
	<div id="og-postbox-container" class="og-postbox-container" style="">

  <Layer v-for="item in store.domelements.slice().reverse()" :item="item" :key="item.id" />

  </div><!-- #postbox_temp-container -->
</div><!-- #layers_temp -->

  <!--<div @click="createsnp()" id="snapshot" style="background-color:#ff0000;">Kreiraj fotku</div>
  <div @click="sortiraj()" id="sortshot" style="background-color:#00ff00;">Serijalizuj sortable</div>
  <div @click="obrisi()" id="sortshot" style="background-color:#0000ff;">Obrisi</div>-->

  </div>

</template>